module.exports = __webpack_public_path__ + "img/wechat.8134af64.jpg";